import CheckIcon from '@mui/icons-material/Check';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const ProductBenefitsList = superstyled({
  tag: Stack,
  name: 'ProductBenefits',
  slot: 'ProductBenefitsList',
  styles: ({ theme }) => ({
    marginTop: theme.spacing(1),
  }),
});

export const ProductBenefitsCheckIcon = superstyled({
  tag: CheckIcon,
  name: 'ProductBenefits',
  slot: 'ProductBenefitsCheckIcon',
  styles: ({ theme }) => ({
    color: theme.palette.success.main,
    fontSize: '1.5rem',
    marginTop: '0.125rem',
  }),
});
